module.exports = __webpack_public_path__ + "static/media/YM83_1.64e16b9f.jpg";